import { render, staticRenderFns } from "./TabBottom.vue?vue&type=template&id=de644004"
import script from "./TabBottom.vue?vue&type=script&lang=js"
export * from "./TabBottom.vue?vue&type=script&lang=js"
import style0 from "./TabBottom.vue?vue&type=style&index=0&id=de644004&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/srv/app/components/button/Button.vue').default})
